import {Controller} from "stimulus"
import noUiSlider from 'nouislider/distribute/nouislider.min'
import wNumb from 'wnumb/wNumb.min'

export default class extends Controller {
  static targets = [
    'slider',
    'bags',
    'seals',
    'container',
  ]

  connect() {
    noUiSlider.create(this.sliderTarget, {
      connect: 'lower',
      start: this.startValue(),
      range: {
        min: 0,
        max: 100
      },
      orientation: 'horizontal',

      tooltips: true,
      format: wNumb({
        decimals: 0,
      })
    })

    this.sliderTarget.noUiSlider.on('update', (values) => {
      this.calculateSeals()
      this.containerTarget.innerHTML = values[0] + '%'
    })
  }

  startValue() {
    return Math.ceil(this.data.get('default') * 100 / (this.bagsTarget.value || 30))
  }

  updateSeals() {
    this.calculateSeals()
  }

  calculateSeals() {
    if (Number.isInteger(parseInt(this.bagsTarget.value))) {
      let value = parseInt(this.bagsTarget.value * this.sliderTarget.noUiSlider.get() / 100)
      let steps = 10 ** parseInt(Math.log10(value / 10))
      steps = Math.max(steps, 5)
      value = parseInt(value / steps)
      value = value * steps
      if (Number.isNaN(value)) {
        this.sealsTarget.value = 0
      } else {
        this.sealsTarget.value = value
      }
    }
  }

  disconnect() {
    this.sliderTarget.noUiSlider.destroy()
  }
}
